import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {Subscription} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {AcademicCalendarService} from "../../../../shared/services/academic-calendar.service";
import {SchoolProgramActivityModel} from "../../../../shared/models/school-program-activity-model";
import {SchoolProgramService} from "../../../../shared/services/school-program.service";
import Swal from "sweetalert2";
import {ThemePalette} from "@angular/material/core";
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from 'src/shared/services/translate.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { AuthService } from 'src/shared/services/auth.service';
import { SetupService } from 'src/shared/services/setup.service';
import { ActivityGridComponent } from '../activity-grid/activity-grid.component';


@Component({
  selector: 'app-activity-list',
  templateUrl: './activity-list.component.html',
  styleUrl: './activity-list.component.scss'
})
export class ActivityListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('viewActivity', {static: true}) public modalViewActivity: NgbModalRef;
  @ViewChild('addActivity', {static: true}) public modalAddActivity: NgbModalRef;
  @ViewChild('modalExport', {static: true}) public modalExport: NgbModalRef;
  @ViewChild('participantListModal', {static: true}) public modalParticipantList: NgbModalRef;

  heading = "Activity";
  loading = {
    list: false,
    student: false,
    unRegis: false,
    detail: false,
    export: false,
    participantList: false,
  }
  color: ThemePalette = 'primary';

  paramForm: FormGroup;
  currentPage = 1;
  schoolActivities:any = [];
  checkedActivity = false;
  total = 0;
  currentAcademic = null;
  hasData = false;
  detailData: any;
  periodSetupSettingDetail: any;
  disabledEditParticipant = true;
  columnsToDisplay = ['activity_name','activity_description', 'participants_1', 'participants_2'];
  newSchoolActivityForm: FormGroup;
  editActivityForm: FormGroup;
  checkApiRun: Subscription;

  disableButtonAdd = true;
  disableButtonEdit = true;

  searchFilterRegistered: string = '';
  searchFilterUnregistered: string = '';

  schoolDay = ['Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday'];
  selectedSchoolDay: String[] = [];
  session: number;

  sort = 'asc';
  orderBy = 'activity_name'
  yearLevelIds: any = null;

  studentSelectedGanjil = false;
  studentDeleteSelectedGanjil = false;
  selectedStudentIdGanjil: any = [];
  selectedtDeleteStudentIdGanjil: any = [];
  unRegisteredStudentGanjil: any = null;
  participantDataGanjil: any = null;
  unRegisteredStudentGanjilNonFiltered: any = null;
  participantDataGanjilNonFiltered: any = null;

  studentSelectedGenap= false;
  studentDeleteSelectedGenap: any = false;
  selectedStudentIdGenap: any = [];
  selectedtDeleteStudentIdGenap: any = [];
  unRegisteredStudentGenap: any = null;
  participantDataGenap: any = null;
  unRegisteredStudentGenapNonFiltered: any = null;
  participantDataGenapNonFiltered: any = null;
  
  periodId: any = null;
  toggle: boolean = true;
  activityId: any = null;

  participantOnlyList: any[] = [];
  registrantOnlyList: any[] = [];
  participantListActivityName: string = '';
  participantListPeriod: number = 1;

  subscriptionExport: Subscription | null = null;
  subscription: any = {};
  loadingAll: any = {};

  allColumn: any = [
    { name: 'No', check: true },
    { name: 'Academic Year', check: true },
    { name: 'School Location', check: true },
    { name: 'School Program', check: true },
    { name: 'Category', check: true },
    { name: 'Activity Name', check: true },
    { name: 'Session', check: true },
    { name: 'Schedule', check: true },
    { name: 'Supervisor', check: true },
    { name: 'Coach', check: true },
    { name: 'Min-Max Participant', check: true },
    { name: 'Participation Fee', check: true },
    { name: 'Start Date', check: true },
    { name: 'End Date', check: true },
    { name: 'NIS', check: true },
    { name: 'NISN', check: true },
    { name: 'Student Name', check: true },
    { name: 'Class Name', check: true },
    { name: 'Paid Amount', check: true },
    { name: 'Student Participated Period', check: true },
    { name: 'Total Participant and Register in Period', check: true },
  ];

  constructor(
    private schoolProgramService: SchoolProgramService,
    private toastr: ToastrService,
    private academicService: AcademicCalendarService,
    public modalService: NgbModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private rpSer: ResponseService,
    public auth: AuthService,
    private setupService: SetupService
  ) {
    this.auth.loadPermissions(true);
    this.translate.load('activity', 'extracurricular', 'scoring');
  }

  ngOnInit(): void {
    if (this.auth.permissions['SCHOOL_PROGRAM_ACTIVITY_EDIT'] || this.auth.permissions['SCHOOL_PROGRAM_ACTIVITY_DELETE']) {
      this.columnsToDisplay.push('action')
    }
    this.initForm();
    this.trackFormChanges();
  }

  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_short_address': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'school_program_name': new FormControl(null),
      'school_program_category_id': new FormControl(null),
      'category_name': new FormControl(null),
      'year_level_id': new FormControl(null)

    });

    this.newSchoolActivityForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'school_program_category_id': new FormControl(null),
      'activity_name': new FormControl(null),
      'activity_description': new FormControl(null),
      'year_level_id':new FormControl(null),
      'activity_schedule': this.formBuilder.array([]),
      'start_date': new FormControl(null),
      'end_date': new FormControl(null),
      'sessions': new FormControl(0),
      'max_registration_day': new FormControl(null),
      'min_participant': new FormControl(null),
      'max_participant': new FormControl(null),
      'participation_fee': new FormControl('0'),
    })

    this.editActivityForm = new FormGroup({
      'school_program_activity_id': new FormControl(null),
      'activity_name': new FormControl(null),
      'activity_description': new FormControl(null),
      'year_level_id': new FormControl(null),
      'school_location_id': new FormControl(null)
    })
  }
  ngAfterViewInit() {
    this.schoolActivities.paginator = this.paginator;
  }
  onChangeColumn(column: any) {
    column.check = !column.check;
  }
  onSort(order: string) {
   this.sort = this.sort == 'asc' ? 'desc' : 'asc';
    this.orderBy = order;

    this.getSchoolActivities();
  }
  trackFormChanges() {
    this.newSchoolActivityForm.valueChanges.subscribe(() => {
      this.disableButtonAdd =
          !this.newSchoolActivityForm.get('activity_name')?.value ||
          !this.newSchoolActivityForm.get('activity_description')?.value ||
          !this.newSchoolActivityForm.get('school_program_category_id')?.value ||
          !this.newSchoolActivityForm.get('year_level_id')?.value
    });

    // this.editActivityForm.valueChanges.subscribe(() => {
    //   this.disableButtonEdit =
    //       !this.editActivityForm.get('activity_name')?.value ||
    //       !this.editActivityForm.get('activity_description')?.value ||
    //       !this.editActivityForm.get('school_program_activity_id')?.value
    // });
  }
  onChangeAcademicYear(item: any, action = 'list') {

    if (action == 'list') {
      this.paramForm.controls['academic_year'].markAsTouched();
      this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);

      this.paramForm.controls['school_location_id'].setValue(null);
    } else if (action =='add') {
      this.newSchoolActivityForm.controls['academic_year'].markAsTouched();
      this.newSchoolActivityForm.controls['academic_year'].setValue(item ? item.academic_year : null);

      this.newSchoolActivityForm.controls['school_location_id'].setValue(null);
    }
    this.checkedActivity = false;

  }

  onChangeSchoolLevel(item: any, action = 'list') {

    if (action == 'list') {
      this.paramForm.controls['school_location_id'].markAsTouched();
      this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

      this.paramForm.controls['school_short_address'].markAsTouched();
      this.paramForm.controls['school_short_address'].setValue(item ? item.school_short_address : null);

      this.paramForm.controls['school_level_id'].markAsTouched();
      this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

      this.paramForm.controls['year_level_id'].setValue(null);
      this.paramForm.controls['school_program_id'].setValue(null);

      this.getSchoolActivities();

    } else if (action =='add') {
      this.newSchoolActivityForm.controls['school_level_id'].markAsTouched();
      this.newSchoolActivityForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

      this.newSchoolActivityForm.controls['school_location_id'].markAsTouched();
      this.newSchoolActivityForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

      this.newSchoolActivityForm.controls['year_level_id'].setValue(null);
      this.newSchoolActivityForm.controls['school_program_id'].setValue(null);
    }
    this.checkedActivity = true;

  }
  onChangeYearLevel(item: any, action = 'list') {
    if (!item) {
      return;
    }
    if (action =='list') {
      this.paramForm.controls['year_level_id'].markAsTouched();
      const data = [item.year_level_id];
      this.paramForm.controls['year_level_id'].setValue(data.length > 0 ? data : null);
      this.getSchoolActivities();

    } else if(action =='add') {
      this.newSchoolActivityForm.controls['year_level_id'].markAsTouched();
      const data = item.map((i: { year_level_id: any; }) => i.year_level_id);
      this.newSchoolActivityForm.controls['year_level_id'].setValue(data.length > 0 ? data : null);
      this.newSchoolActivityForm.controls['school_program_id'].setValue(null);
    } else if(action == 'edit') {
      this.editActivityForm.controls['year_level_id'].markAsTouched();
      const data = item.map((i: { year_level_id: any; }) => i.year_level_id);
      this.editActivityForm.controls['year_level_id'].setValue(data.length > 0 ? data : null);
    }
    this.checkedActivity = true;

  }
  onChangeSchoolProgram(item: any, action = 'list') {
    console.log('MASUK');

    if (action == 'list') {
      this.paramForm.controls['school_program_id'].markAsTouched();
      this.paramForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);

      this.paramForm.controls['school_program_name'].markAsTouched();
      this.paramForm.controls['school_program_name'].setValue(item ? item.school_program_name : null);

      this.paramForm.controls['school_program_category_id'].setValue(null);
      this.getSchoolActivities();


    } else if (action =='add') {
      this.newSchoolActivityForm.controls['school_program_id'].markAsTouched();
      this.newSchoolActivityForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);

      this.newSchoolActivityForm.controls['school_program_category_id'].setValue(null);
    } else {

    }
    this.checkedActivity = true;
  }

  onChangeSchoolProgramCategory(item: any, action = 'list') {

    if (action == 'list') {
      this.paramForm.controls['school_program_category_id'].markAsTouched();
      this.paramForm.controls['school_program_category_id'].setValue(item ? item.school_program_category_id : null);

      this.paramForm.controls['category_name'].markAsTouched();
      this.paramForm.controls['category_name'].setValue(item ? item.category_name : null);

      this.getSchoolActivities();
    } else if (action =='add') {
      this.newSchoolActivityForm.controls['school_program_category_id'].markAsTouched();
      this.newSchoolActivityForm.controls['school_program_category_id'].setValue(item ? item.school_program_category_id : null);
    }
    this.checkedActivity = true;

  }

  onChangePage(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;

    this.getSchoolActivities();
  }

  onSearchFilterRegistered() {
    if (this.searchFilterRegistered !== '') {
      this.selectedtDeleteStudentIdGanjil = [];
      this.selectedStudentIdGanjil = [];

      this.selectedtDeleteStudentIdGenap = [];
      this.selectedStudentIdGenap = [];

      this.participantDataGanjil = this.participantDataGanjilNonFiltered;
      this.participantDataGenap = this.participantDataGenapNonFiltered;
      this.participantDataGanjil = this.participantDataGanjil ?
      this.participantDataGanjil.filter((student: any) =>
          student.student_name.toLowerCase().includes(this.searchFilterRegistered.toLowerCase()) ||
          student.class_name.toLowerCase().includes(this.searchFilterRegistered.toLowerCase())
      ) : null;

      this.participantDataGenap = this.participantDataGenap ?
        this.participantDataGenap.filter((student: any) =>
          student.student_name.toLowerCase().includes(this.searchFilterRegistered.toLowerCase()) ||
          student.class_name.toLowerCase().includes(this.searchFilterRegistered.toLowerCase())
      ) : null;
    } else {
      this.participantDataGanjil = this.participantDataGanjilNonFiltered;
      this.participantDataGenap = this.participantDataGenapNonFiltered;
    }
  }

  onSearchFilterUnregistered() {
    if (this.searchFilterUnregistered !== '') {
      this.selectedtDeleteStudentIdGanjil = [];
      this.selectedStudentIdGanjil = [];

      this.selectedtDeleteStudentIdGenap = [];
      this.selectedStudentIdGenap = [];

      this.unRegisteredStudentGenap = this.unRegisteredStudentGenapNonFiltered;
      this.unRegisteredStudentGanjil = this.unRegisteredStudentGanjilNonFiltered;
      this.unRegisteredStudentGenap = this.unRegisteredStudentGenap ?
        this.unRegisteredStudentGenap.filter((student: any) =>
          student.student_name.toLowerCase().includes(this.searchFilterUnregistered.toLowerCase()) ||
          student.class_name.toLowerCase().includes(this.searchFilterUnregistered.toLowerCase())
      ) : null;

      this.unRegisteredStudentGanjil = this.unRegisteredStudentGanjil ?
        this.unRegisteredStudentGanjil.filter((student: any) =>
          student.student_name.toLowerCase().includes(this.searchFilterUnregistered.toLowerCase()) ||
          student.class_name.toLowerCase().includes(this.searchFilterUnregistered.toLowerCase())
      ) : null;
    } else {
      this.unRegisteredStudentGenap = this.unRegisteredStudentGenapNonFiltered;
      this.unRegisteredStudentGanjil = this.unRegisteredStudentGanjilNonFiltered;
    }
  }

  async onToggle() {
    this.toggle = !this.toggle;
    this.loading.student = true;
    this.loading.unRegis = true;

    this.selectedtDeleteStudentIdGanjil = [];
    this.selectedStudentIdGanjil = [];

    this.selectedtDeleteStudentIdGenap = [];
    this.selectedStudentIdGenap = [];

    this.unRegisteredStudentGenap =null;
    this.unRegisteredStudentGanjil = null;

    this.participantDataGenap = null;
    this.participantDataGanjil = null;
    if (this.toggle) {
      await this.getParticipantList(this.activityId, null);
      await this.getunRegisteredStudentList(this.activityId, null);

    } else {
      await this.getParticipantList(this.activityId, 1);
      await this.getunRegisteredStudentList(this.activityId, 1);

      await this.getParticipantList(this.activityId, 2);
      await this.getunRegisteredStudentList(this.activityId, 2);
    }
  }
  getSchoolActivities () {
    if (!this.paramForm.get('academic_year')?.value) {
      return;
    }

    this.loading.list = true;
    if (this.checkApiRun) {
      this.checkApiRun.unsubscribe();
    }
    this.checkApiRun = this.schoolProgramService.getSchoolProgramActivity({
      school_program_id: this.paramForm.get('school_program_id')?.value,
      school_program_category_id: this.paramForm.get('school_program_category_id')?.value,
      school_location_id: this.paramForm.get('school_location_id')?.value,
      page: this.currentPage,
      pagination: true,
      sort: this.sort,
      orderBy: this.orderBy,
      year_level_id: this.paramForm.get('year_level_id')?.value,
      academic_year: this.paramForm.get('academic_year')?.value,
      approved: 'all',
    })
        .subscribe(
            (response: SchoolProgramActivityModel) => {
              // @ts-ignore
              if (response['status']) {
                // @ts-ignore
                this.schoolActivities = response['data'].slice();
                this.checkedActivity = true;
                // @ts-ignore
                this.total = response['meta']['total'];
                this.hasData = this.total > 0;
                this.loading.list = false;
              } else {
                // @ts-ignore
                this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
                this.loading.list = false;
              }
            },
            error => {
              this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
              this.loading.list = false;
            });
  }

  async getActivityDetail(data: any) {
    this.participantDataGanjil = null;
    this.unRegisteredStudentGanjil = null;
    this.activityId = data.school_program_activity_id;
    const id = data.school_program_activity_id;
    this.selectedtDeleteStudentIdGanjil = [];
    this.selectedStudentIdGanjil = [];
    this.toggle = true;
    this.detailData = [];
    this.loading.detail = true;
    this.schoolProgramService.getSchoolProgramActivityDetail(id)
        .subscribe(
            async (response: SchoolProgramActivityModel) => {
              // @ts-ignore
              if (response['status']) {
                // @ts-ignore
                this.detailData = response['data'];
                this.editActivityForm.patchValue({
                  school_program_activity_id: this.detailData.school_program_activity_id,
                  activity_name: this.detailData.activity_name,
                  activity_description: this.detailData.activity_description,
                  school_location_id: this.detailData.school_location_id
                });
                this.yearLevelIds = this.detailData.year_level;
                await this.getParticipantList(this.activityId, null);
                await this.getunRegisteredStudentList(this.activityId, null);
                this.loading.detail = false;
              } else {
                // @ts-ignore
                this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
                this.loading.detail = false;
              }
            },
            error => {
              this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
              this.loading.detail = false;
            });
  }

    getPeriodSetupSettingNow() {
    const params = {
      year_level_id: this.detailData.activity.year_level.map((i: { year_level_id: any; }) => i.year_level_id),
      school_location_id: this.detailData.activity.school_location_id,
    }
    this.setupService.getPeriodSetupSetting(params).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.periodSetupSettingDetail = response.data;
          // take the oldest "start_date" and the newest "end_date" from the period setup setting
          if (this.periodSetupSettingDetail.length > 0) {
            this.periodId = this.periodSetupSettingDetail[0].period_setup_id;
            const startDate = new Date(Math.min(...this.periodSetupSettingDetail.map((item: { start_date: string; }) => new Date(item.start_date).getTime())));
            const endDate = new Date(Math.max(...this.periodSetupSettingDetail.map((item: { end_date: string; }) => new Date(item.end_date).getTime())));
            if (new Date() <= endDate && new Date() >= startDate) {
              this.disabledEditParticipant = true;
            } else {
              this.disabledEditParticipant = false;
            }
          }
        } else {
          this.rpSer.showEditFailed(response.message ? response.message : 'Failed to load period setup setting');
        }
      },
      error: (error: any) => {
        this.rpSer.showEditFailed();
      }
    });
  }

  onOpenModelAddActivity () {
    this.router.navigate(['add'], {relativeTo: this.route});
  }
  onOpenActivityGrid(): void {
    const modalRef = this.modalService.open(ActivityGridComponent, {
      size: 'xl', keyboard: false, backdrop: 'static', centered: true,
    });
    modalRef.componentInstance.filters = this.paramForm.getRawValue();
    modalRef.result.then(() => this.getSchoolActivities(), () => {});
  }
  editActivity(id :number) {
    this.router.navigate(['edit/' + id], {relativeTo: this.route});
  }
  async onOpenModalViewActivity(data: any) {
    // this.participantDataGanjil = null;
    // this.unRegisteredStudentGanjil = null;
    // this.activityId = data.school_program_activity_id;

    await this.getActivityDetail(data);

    this.modalService.open(this.modalViewActivity, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: true,
      size: 'lg'
    }).result.then((result: any) => {
    }, (reason: any) => {
    });
  }
  onOpenParticipantList(data: any, period: number) {
    if (!this.auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_VIEW']) {
      return;
    }
    this.participantOnlyList = [];
    this.registrantOnlyList = [];
    this.participantListActivityName = data.activity_name;
    this.participantListPeriod = period;
    this.loading.participantList = true;

    this.modalService.open(this.modalParticipantList, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: true,
      size: 'lg'
    });

    this.schoolProgramService.getActivityParticipantList({
      school_program_activity_id: data.school_program_activity_id,
      period_id: period
    }).subscribe(
        (response: any) => {
          if (response['status']) {
            const list = response['data'] ? response['data'] : [];
            // participants have activity_participant_id set, registrants have it null
            this.participantOnlyList = list.filter((item: any) => item.activity_participant_id);
            this.registrantOnlyList = list.filter((item: any) => !item.activity_participant_id);
            this.loading.participantList = false;
          } else {
            this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
            this.loading.participantList = false;
          }
        },
        error => {
          this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
          this.loading.participantList = false;
        });
  }

  deleteActivity(data: any)  {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this activity?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.schoolProgramService.deleteSchoolProgramActivity(data.school_program_activity_id).subscribe(
            async (response: any) => {
              if (response['status']) {
                this.rpSer.showDeleteSuccess();
                this.getSchoolActivities();

              } else {
                this.rpSer.showDeleteFailed();
              }
            },
            (error: any) => {
              this.rpSer.showDeleteFailed();
            }
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {

      }
    });
  }

  slotPercent(count: number, max: number): number {
    if (!max || max <= 0) {
      return 0;
    }
    const pct = ((count || 0) / max) * 100;
    return Math.max(0, Math.min(100, Math.round(pct)));
  }

  slotClass(count: number, max: number): string {
    const pct = this.slotPercent(count, max);
    if (pct >= 100) {
      return 'slot-100';
    }
    if (pct >= 95) {
      return 'slot-95';
    }
    return 'slot-0';
  }

  onExportToPdf(school_program_activity_id: number)  {
    if (this.subscription.export_pdf) {
      this.subscription.export_pdf.unsubscribe();
    }

    this.loadingAll.export_pdf = true;
    this.subscription.export_pdf = this.schoolProgramService.getActivityParticipantReport(school_program_activity_id).subscribe(
      (response: any) => {
        if (response) {
          this.loadingAll.export_pdf = false;
          const blobUrl = URL.createObjectURL(response as any);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.target = '_blank';
          link.click();
          URL.revokeObjectURL(blobUrl);
        } else {
          this.loadingAll.export_pdf = false;
          this.rpSer.showAddError();
        }
      },
      (error: any) => {
        this.loadingAll.export_pdf = false;
        this.rpSer.showAddError();
      }
    );
  }

  onAddActivity() {
    const data = this.newSchoolActivityForm.value;
    this.schoolProgramService.createSchoolProgramActivity(data).subscribe(
        (response: any) => {
          if (response['status']) {
            this.rpSer.showAddSuccess('The school program activity has been added successfully.');
            this.modalService.dismissAll();
            this.getSchoolActivities();
          } else {
            // Swal.fire({
            //   title: 'Error',
            //   text: 'Failed to add the school program activity. Please try again.',
            //   icon: 'error',
            //   confirmButtonText: 'Retry',
            // });
            this.rpSer.showAddError('Failed to add the school program activity. Please try again.');
          }
        },
        (error: any) => {
          // Swal.fire({
          //   title: 'Error',
          //   text: 'An unexpected error occurred. Please check your connection and try again.',
          //   icon: 'error',
          //   confirmButtonText: 'Retry',
          // });
          this.rpSer.showAddError();
        }
    );
  }

  onSaveDetail() {
    const data = {
      school_program_activity_id: this.detailData.school_program_activity_id,
      activity_name: this.editActivityForm.get('activity_name')?.value,
      activity_description: this.editActivityForm.get('activity_description')?.value,
      all_period: this.toggle,
      manage_participant_only: true,
      studentAdd:  {
        ganjil:this.selectedStudentIdGanjil,
        genap: this.selectedStudentIdGenap
      },
      studentRemove: {
        ganjil: this.selectedtDeleteStudentIdGanjil,
        genap: this.selectedtDeleteStudentIdGenap
      },
      year_level_id: this.editActivityForm.get('year_level_id')?.value,
      data: this.editActivityForm.value
    }
    this.schoolProgramService.updateSchoolProgramActivity(data).subscribe(
        (response: any) => {
          if (response['status']) {
            this.rpSer.showEditSuccess('The school program activity has been updated successfully.');
            this.modalService.dismissAll();
            this.getSchoolActivities();
          } else {
            this.rpSer.showEditFailed('Failed to update the school program activity. Please try again.');
          }
        },
        (error: any) => {
          this.rpSer.showEditFailed();
        }
    );
  }

  async getParticipantList(schoolProgramId: any, periodId: any = null){
    this.loading.student = true;
    this.schoolProgramService.getActivityParticipantList({
      school_program_activity_id: schoolProgramId,
      period_id: periodId
    })
        .subscribe(
            (response: any) => {
              // @ts-ignore
              if (response['status']) {
                // @ts-ignore
                if (periodId == 1) {
                  this.participantDataGanjil = response['data'] ? response['data'].slice() : null;
                } else if(periodId == 2) {
                  this.participantDataGenap = response['data'] ? response['data'].slice() : null;
                } else {
                  this.participantDataGanjil = response['data'] ? response['data'].slice() : null;
                  this.participantDataGenap = response['data'] ? response['data'].slice() : null;
                }
                this.participantDataGanjilNonFiltered = this.participantDataGanjil;
                this.participantDataGenapNonFiltered = this.participantDataGenap;
                this.loading.student = false;
              } else {
                // @ts-ignore
                this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
                this.loading.student = false;
              }
            },
            error => {
              this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
              this.loading.student = false;
            });
  }

  async getunRegisteredStudentList(schoolProgramId: any, periodId: any = null){
    this.loading.unRegis = true;
    console.log(this.detailData);
    this.schoolProgramService.getUnregisteredStudentList({
      school_program_activity_id: schoolProgramId,
      period_id: periodId,
      academic_year: this.paramForm.get('academic_year')?.value,
      year_level_id: this.detailData.activity.year_level.map((i: { year_level_id: any; }) => i.year_level_id),
      school_location_id: this.detailData.activity.school_location_id
    })
        .subscribe(
            (response: any) => {
              // @ts-ignore
              if (response['status']) {
                // @ts-ignore
                if (periodId == 1) {
                  this.unRegisteredStudentGanjil = response['data'] ? response['data'].slice() : null;
                } else if (periodId == 2) {
                  this.unRegisteredStudentGenap = response['data'] ? response['data'].slice() : null;
                } else {
                  this.unRegisteredStudentGanjil = response['data'] ? response['data'].slice() : null;
                  this.unRegisteredStudentGenap = response['data'] ? response['data'].slice() : null;
                }
                this.unRegisteredStudentGanjilNonFiltered = this.unRegisteredStudentGanjil;
                this.unRegisteredStudentGenapNonFiltered = this.unRegisteredStudentGenap;
                this.loading.unRegis = false;
              } else {
                // @ts-ignore
                this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
                this.loading.unRegis = false;
              }
            },
            (error:any) => {
              this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
              this.loading.unRegis = false;
            });
  }

  isChecked(id: number) {
    // @ts-ignore
    const index = this.selectedStudentIdGanjil.indexOf(id);
    return index !== -1;
  }
  onChecked(id: number) {
    // @ts-ignore
    const index = this.selectedStudentIdGanjil.indexOf(id);

    if (index === -1) {
      this.studentSelectedGanjil = true;
      // @ts-ignore
      this.selectedStudentIdGanjil.push(id);
    } else {
      this.selectedStudentIdGanjil.splice(index, 1);
    }

    if (this.selectedStudentIdGanjil.length === 0) {
      this.studentSelectedGanjil = false;
    }
  }
  isDelete(id: number): boolean {
    // @ts-ignore
    return this.selectedtDeleteStudentIdGanjil.includes(id);
  }
  onRemove(id: number) {
    // @ts-ignore
    const index = this.selectedtDeleteStudentIdGanjil.indexOf(id);

    if (index === -1) {
      this.studentDeleteSelectedGanjil = true;
      // @ts-ignore
      this.selectedtDeleteStudentIdGanjil.push(id);
    } else {
      this.selectedtDeleteStudentIdGanjil.splice(index, 1);
    }

    if (this.selectedtDeleteStudentIdGanjil.length === 0) {
      this.studentDeleteSelectedGanjil = false;
    }
  }
  onCancel() {
    this.selectedtDeleteStudentIdGanjil = [];
    this.selectedStudentIdGanjil = [];
    this.activityId = null;
    this.modalService.dismissAll();
  }

  isCheckedGenap(id: number) {
    // @ts-ignore
    const index = this.selectedStudentIdGenap.indexOf(id);
    return index !== -1;
  }
  onCheckedGenap(id: number) {
    // @ts-ignore
    const index = this.selectedStudentIdGenap.indexOf(id);

    if (index === -1) {
      this.studentSelectedGenap = true;
      // @ts-ignore
      this.selectedStudentIdGenap.push(id);
    } else {
      this.selectedStudentIdGenap.splice(index, 1);
    }

    if (this.selectedStudentIdGenap.length === 0) {
      this.studentSelectedGenap = false;
    }
  }
  isDeleteGenap(id: number): boolean {
    // @ts-ignore
    return this.selectedtDeleteStudentIdGenap.includes(id);
  }
  onRemoveGenap(id: number) {
    // @ts-ignore
    const index = this.selectedtDeleteStudentIdGenap.indexOf(id);

    if (index === -1) {
      this.studentDeleteSelectedGenap = true;
      // @ts-ignore
      this.selectedtDeleteStudentIdGenap.push(id);
    } else {
      this.selectedtDeleteStudentIdGenap.splice(index, 1);
    }

    if (this.selectedtDeleteStudentIdGenap.length === 0) {
      this.studentDeleteSelectedGenap = false;
    }
  }

  get activitySchedule(): FormArray {
    return this.newSchoolActivityForm.get('activity_schedule') as FormArray;
  }

  addSchedule(day: string) {
    this.activitySchedule.push(
      this.formBuilder.group({
        day: day,
        time_start: new FormControl(null),
        time_end: new FormControl(null),
        venue: new FormControl(''),
        equipment: new FormControl('')
      })
    );
  }

  onChangeSchoolDay(selectedDays: string[]) {
    this.activitySchedule.clear();
    selectedDays.forEach(day => {
      this.addSchedule(day);
      this.selectedSchoolDay.push(day);
    });
    this.session_count();
  }

  session_count() {
    const start = this.newSchoolActivityForm.controls['start_date'].value;
    const end = this.newSchoolActivityForm.controls['end_date'].value;
    if (start && end) {
      let sessionCounter = 0;
      for (var d = new Date(start); d <= new Date(end); d.setDate(d.getDate() + 1)) {
        for (let i = 0; i < this.selectedSchoolDay.length; i++) {
          if (d.toString().split(' ')[0] === this.selectedSchoolDay[i].substring(0,3)) {
            sessionCounter++;
          }
        }
      }
      this.newSchoolActivityForm.patchValue({sessions: sessionCounter});
    } else {
      this.newSchoolActivityForm.patchValue({sessions: 0});
    }
  }

  onClickExport() {
    this.modalService.open(this.modalExport, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      size: 'lg'
    });
  }

  onExportToExcel() {
    if (this.subscriptionExport) {
      this.subscriptionExport.unsubscribe();
    }

    this.loading.export = true;

    this.subscriptionExport = this.schoolProgramService.exportActivityToExcel({
      ...this.paramForm.value,
      sort: this.sort,
      orderBy: this.orderBy,
      columns: this.allColumn
    }).subscribe({
      next: (response: Blob) => {
        try {
          // Validate response is actually a blob/file
          if (!response || response.size === 0) {
            throw new Error('Empty file received from server');
          }

          // Check if response is an error (sometimes APIs return JSON error as blob)
          if (response.type === 'application/json') {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result as string);
                this.rpSer.showAddError(errorData.message || 'Export failed');
              } catch {
                this.rpSer.showAddError('Invalid response format');
              }
            };
            reader.readAsText(response);
            this.loading.export = false;
            return;
          }

          // Generate filename with timestamp
          const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
          const filename = `School_Program_Activity_List_${timestamp}.xlsx`;
          
          // Create and trigger download
          const blobUrl = URL.createObjectURL(response);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = filename;
          link.style.display = 'none';
          
          // Add to DOM, click, and cleanup
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          // Cleanup blob URL after a delay to ensure download starts
          setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
          }, 1000);
          
          this.loading.export = false;
          this.rpSer.showAddSuccess('Report exported successfully!');
          
        } catch (error: any) {
          this.loading.export = false;
          this.rpSer.showAddError(`Export failed: ${error.message}`);
        }
      },
      error: () => {
        this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
        this.loading.export = false;
      }
    });
  }

  isCheckAllGanjil(): boolean {
    if (this.unRegisteredStudentGanjil && this.unRegisteredStudentGanjil.length > 0) {
      return this.unRegisteredStudentGanjil.every((item: any) => this.isChecked(item.student_id));
    }
    return false;
  }

  isCheckAllGenap(): boolean {
    if (this.unRegisteredStudentGenap && this.unRegisteredStudentGenap.length > 0) {
      return this.unRegisteredStudentGenap.every((item: any) => this.isCheckedGenap(item.student_id));
    }
    return false;
  }

  onCheckAllGanjil() {
    if (this.isCheckAllGanjil()) {
      // Uncheck all
      this.unRegisteredStudentGanjil.forEach((item: any) => {
        const index = this.selectedStudentIdGanjil.indexOf(item.student_id);
        if (index !== -1) {
          this.selectedStudentIdGanjil.splice(index, 1);
        }
      });
      this.studentSelectedGanjil = false;
    } else {
      // Check all
      this.unRegisteredStudentGanjil.forEach((item: any) => {
        if (!this.isChecked(item.student_id)) {
          this.selectedStudentIdGanjil.push(item.student_id);
        }
      });
      this.studentSelectedGanjil = true;
    }
  }

  onCheckAllGenap() {
    if (this.isCheckAllGenap()) {
      // Uncheck all
      this.unRegisteredStudentGenap.forEach((item: any) => {
        const index = this.selectedStudentIdGenap.indexOf(item.student_id);
        if (index !== -1) {
          this.selectedStudentIdGenap.splice(index, 1);
        }
      });
      this.studentSelectedGenap = false;
    } else {
      // Check all
      this.unRegisteredStudentGenap.forEach((item: any) => {
        if (!this.isCheckedGenap(item.student_id)) {
          this.selectedStudentIdGenap.push(item.student_id);
        }
      });
      this.studentSelectedGenap = true;
    }
  }
}
